module.exports = __webpack_public_path__ + "static/control-panel-4a0f7c91602dade44458c32e29625594.png";